import { Purpose } from "../../modules";

const QuestionnairePurpose = () => {
  return <Purpose />;
};

export { QuestionnairePurpose };
